// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== REWARD CENTER STYLES ====================
   Prefix: rc- to avoid collisions
   ============================================================ */

   .rc-root {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  /* ── Loading State ──────────────────────────────────────────────── */
  .rc-loading {
    padding: 60px 40px;
    text-align: center;
    color: rgba(255, 255, 255, 0.50);
    font-size: 16px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px dashed rgba(255, 255, 255, 0.10);
    border-radius: 12px;
    margin-top: 20px;
  }
  
  /* ── Header Section ────────────────────────────────────────────── */
  .rc-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px 24px;
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.12) 0%, rgba(255, 152, 0, 0.08) 100%);
    border: 1px solid rgba(255, 193, 7, 0.20);
    border-radius: 12px;
    margin-bottom: 24px;
  }
  
  .rc-header-icon {
    font-size: 2.5rem;
    flex-shrink: 0;
    line-height: 1;
  }
  
  .rc-header-content {
    flex: 1 1;
  }
  
  .rc-header-title {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 6px 0;
    padding: 0;
  }
  
  .rc-header-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.60);
    margin: 0;
    padding: 0;
    line-height: 1.65;
  }
  
  .rc-header-desc strong {
    color: rgba(255, 255, 255, 0.80);
    font-weight: 700;
  }
  
  /* ── Rules Grid ────────────────────────────────────────────────── */
  .rc-rules-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .rc-rule-card {
    padding: 18px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.02);
    transition: all 0.2s ease;
  }
  
  .rc-rule-card:hover {
    border-color: rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.04);
    transform: translateY(-2px);
  }
  
  .rc-rule-icon {
    font-size: 1.6rem;
    margin-bottom: 10px;
    display: block;
  }
  
  .rc-rule-title {
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 10px 0;
    padding: 0;
  }
  
  .rc-rule-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .rc-rule-list li {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.55);
    padding-left: 18px;
    position: relative;
    line-height: 1.5;
  }
  
  .rc-rule-list li::before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #4caf50;
    font-weight: 700;
  }
  
  /* ── Summary Section ───────────────────────────────────────────── */
  .rc-summary {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 22px;
    margin-bottom: 24px;
  }
  
  .rc-summary-title {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 18px 0;
    padding: 0;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }
  
  .rc-summary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
  }
  
  .rc-summary-col {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .rc-summary-col--highlight {
    background: linear-gradient(135deg, rgba(33, 150, 243, 0.08) 0%, rgba(156, 39, 176, 0.06) 100%);
    border-radius: 10px;
    padding: 16px;
    margin: -16px -16px -16px 0;
    padding-right: 16px;
  }
  
  .rc-summary-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
  }
  
  .rc-summary-item--large {
    padding: 14px 0;
  }
  
  .rc-summary-item--total {
    padding-top: 14px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin-top: 4px;
    font-weight: 700;
  }
  
  .rc-summary-icon {
    font-size: 1.4rem;
    flex-shrink: 0;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .rc-summary-text {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .rc-summary-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(255, 255, 255, 0.40);
    font-weight: 700;
    display: block;
  }
  
  .rc-summary-value {
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    display: block;
  }
  
  .rc-summary-value--large {
    font-size: 28px !important;
    color: #ffd54f !important;
  }
  
  .rc-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.10);
    margin: 8px 0;
  }
  
  /* ── Benefit Section ───────────────────────────────────────────── */
  .rc-benefit {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    padding: 18px 20px;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.10) 0%, rgba(76, 175, 80, 0.05) 100%);
    border: 1px solid rgba(76, 175, 80, 0.20);
    border-radius: 12px;
  }
  
  .rc-benefit-icon {
    font-size: 1.8rem;
    flex-shrink: 0;
    margin-top: 2px;
  }
  
  .rc-benefit-title {
    font-size: 14px;
    font-weight: 700;
    color: #81c784;
    margin: 0 0 5px 0;
    padding: 0;
  }
  
  .rc-benefit-desc {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.55);
    margin: 0;
    padding: 0;
    line-height: 1.65;
  }
  
  /* ── Responsive ────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .rc-rules-grid {
      grid-template-columns: 1fr;
    }
  
    .rc-summary-grid {
      grid-template-columns: 1fr;
    }
  
    .rc-summary-col--highlight {
      margin: 0;
      padding: 14px;
    }
  
    .rc-header {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  
    .rc-header-icon {
      font-size: 2rem;
    }
  
    .rc-benefit {
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
    }
  
    .rc-benefit-icon {
      margin-top: 0;
    }
  }
  
  @media (max-width: 480px) {
    .rc-summary-item {
      padding: 8px 0;
    }
  
    .rc-summary-value {
      font-size: 14px;
    }
  
    .rc-summary-value--large {
      font-size: 20px !important;
    }
  
    .rc-rule-card {
      padding: 14px;
    }
  
    .rc-rule-title {
      font-size: 13px;
    }
  
    .rc-rule-list li {
      font-size: 11px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/Styles/RewardCenter.css"],"names":[],"mappings":"AAAA;;iEAEiE;;GAE9D;IACC,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA,sEAAsE;EACtE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,qCAAqC;IACrC,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,6FAA6F;IAC7F,yCAAyC;IACzC,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,qCAAqC;IACrC,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,gBAAgB;EAClB;;EAEA,qEAAqE;EACrE;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,kDAAkD;EACpD;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,+FAA+F;IAC/F,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;IAChC,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,qCAAqC;IACrC,aAAa;EACf;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,6FAA6F;IAC7F,yCAAyC;IACzC,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,UAAU;IACV,iBAAiB;EACnB;;EAEA,qEAAqE;EACrE;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,SAAS;MACT,aAAa;IACf;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/* ==================== REWARD CENTER STYLES ====================\n   Prefix: rc- to avoid collisions\n   ============================================================ */\n\n   .rc-root {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  /* ── Loading State ──────────────────────────────────────────────── */\n  .rc-loading {\n    padding: 60px 40px;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.50);\n    font-size: 16px;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px dashed rgba(255, 255, 255, 0.10);\n    border-radius: 12px;\n    margin-top: 20px;\n  }\n  \n  /* ── Header Section ────────────────────────────────────────────── */\n  .rc-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 20px 24px;\n    background: linear-gradient(135deg, rgba(255, 193, 7, 0.12) 0%, rgba(255, 152, 0, 0.08) 100%);\n    border: 1px solid rgba(255, 193, 7, 0.20);\n    border-radius: 12px;\n    margin-bottom: 24px;\n  }\n  \n  .rc-header-icon {\n    font-size: 2.5rem;\n    flex-shrink: 0;\n    line-height: 1;\n  }\n  \n  .rc-header-content {\n    flex: 1;\n  }\n  \n  .rc-header-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 6px 0;\n    padding: 0;\n  }\n  \n  .rc-header-desc {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.60);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n  }\n  \n  .rc-header-desc strong {\n    color: rgba(255, 255, 255, 0.80);\n    font-weight: 700;\n  }\n  \n  /* ── Rules Grid ────────────────────────────────────────────────── */\n  .rc-rules-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n  \n  .rc-rule-card {\n    padding: 18px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.02);\n    transition: all 0.2s ease;\n  }\n  \n  .rc-rule-card:hover {\n    border-color: rgba(255, 255, 255, 0.15);\n    background: rgba(255, 255, 255, 0.04);\n    transform: translateY(-2px);\n  }\n  \n  .rc-rule-icon {\n    font-size: 1.6rem;\n    margin-bottom: 10px;\n    display: block;\n  }\n  \n  .rc-rule-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 10px 0;\n    padding: 0;\n  }\n  \n  .rc-rule-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n  \n  .rc-rule-list li {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.55);\n    padding-left: 18px;\n    position: relative;\n    line-height: 1.5;\n  }\n  \n  .rc-rule-list li::before {\n    content: \"✓\";\n    position: absolute;\n    left: 0;\n    color: #4caf50;\n    font-weight: 700;\n  }\n  \n  /* ── Summary Section ───────────────────────────────────────────── */\n  .rc-summary {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n    padding: 22px;\n    margin-bottom: 24px;\n  }\n  \n  .rc-summary-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 18px 0;\n    padding: 0;\n    padding-bottom: 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  }\n  \n  .rc-summary-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n  }\n  \n  .rc-summary-col {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .rc-summary-col--highlight {\n    background: linear-gradient(135deg, rgba(33, 150, 243, 0.08) 0%, rgba(156, 39, 176, 0.06) 100%);\n    border-radius: 10px;\n    padding: 16px;\n    margin: -16px -16px -16px 0;\n    padding-right: 16px;\n  }\n  \n  .rc-summary-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 0;\n  }\n  \n  .rc-summary-item--large {\n    padding: 14px 0;\n  }\n  \n  .rc-summary-item--total {\n    padding-top: 14px;\n    border-top: 1px solid rgba(255, 255, 255, 0.08);\n    margin-top: 4px;\n    font-weight: 700;\n  }\n  \n  .rc-summary-icon {\n    font-size: 1.4rem;\n    flex-shrink: 0;\n    width: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .rc-summary-text {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n  \n  .rc-summary-label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(255, 255, 255, 0.40);\n    font-weight: 700;\n    display: block;\n  }\n  \n  .rc-summary-value {\n    font-size: 16px;\n    font-weight: 700;\n    color: #fff;\n    display: block;\n  }\n  \n  .rc-summary-value--large {\n    font-size: 28px !important;\n    color: #ffd54f !important;\n  }\n  \n  .rc-divider {\n    height: 1px;\n    background: rgba(255, 255, 255, 0.10);\n    margin: 8px 0;\n  }\n  \n  /* ── Benefit Section ───────────────────────────────────────────── */\n  .rc-benefit {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    padding: 18px 20px;\n    background: linear-gradient(135deg, rgba(76, 175, 80, 0.10) 0%, rgba(76, 175, 80, 0.05) 100%);\n    border: 1px solid rgba(76, 175, 80, 0.20);\n    border-radius: 12px;\n  }\n  \n  .rc-benefit-icon {\n    font-size: 1.8rem;\n    flex-shrink: 0;\n    margin-top: 2px;\n  }\n  \n  .rc-benefit-title {\n    font-size: 14px;\n    font-weight: 700;\n    color: #81c784;\n    margin: 0 0 5px 0;\n    padding: 0;\n  }\n  \n  .rc-benefit-desc {\n    font-size: 13px;\n    color: rgba(255, 255, 255, 0.55);\n    margin: 0;\n    padding: 0;\n    line-height: 1.65;\n  }\n  \n  /* ── Responsive ────────────────────────────────────────────────── */\n  @media (max-width: 768px) {\n    .rc-rules-grid {\n      grid-template-columns: 1fr;\n    }\n  \n    .rc-summary-grid {\n      grid-template-columns: 1fr;\n    }\n  \n    .rc-summary-col--highlight {\n      margin: 0;\n      padding: 14px;\n    }\n  \n    .rc-header {\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n    }\n  \n    .rc-header-icon {\n      font-size: 2rem;\n    }\n  \n    .rc-benefit {\n      flex-direction: column;\n      align-items: flex-start;\n      text-align: left;\n    }\n  \n    .rc-benefit-icon {\n      margin-top: 0;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .rc-summary-item {\n      padding: 8px 0;\n    }\n  \n    .rc-summary-value {\n      font-size: 14px;\n    }\n  \n    .rc-summary-value--large {\n      font-size: 20px !important;\n    }\n  \n    .rc-rule-card {\n      padding: 14px;\n    }\n  \n    .rc-rule-title {\n      font-size: 13px;\n    }\n  \n    .rc-rule-list li {\n      font-size: 11px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
